<template lang="html">
  	<a href="#">
  		<div class="toTop">
	    	<img src="../../assets/img/home-to-top.png"/>
	    	<div class="text">返回顶部</div>
	    </div>
	</a>
</template>
<script>
	export default {
	  	name: 'ToTop',
	}
</script>
<style lang="less" scoped>
	.toTop{
		position:fixed;
		bottom:400px;
		right:45px;
		z-index:12;
		background:rgba(51,51,51,0.15);
		width:130px;
		height:130px;
		border-radius:100%;
		img{
			width:40px;
			height:40px;
			margin-left:45px;
			margin-top:15px;
		}
		.text{
			margin-top:5px;
			width:60px;
			margin-left:35px;
			font-size:20px;
			color:#ad8f5a;
			letter-spacing:0.1px;
			line-height:25px;
			text-align:center;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/common/toTop.vue